import Flag from "@app/_components/Flag";
import { Button } from "@ui/button";
import { findMarketByCode } from "../config/market-config";
import { useMarketStore } from "../hooks/useMarketStore";

export default function MarketSelectorButton() {
  const marketCode = useMarketStore((state) => state.market);
  const setOpen = useMarketStore((state) => state.setOpen);

  const market = findMarketByCode(marketCode ?? "", false);

  return (
    <Button variant="ghost" onClick={() => setOpen(true)} className="gap-x-2">
      {market ? (
        <>
          <Flag
            className="size-3 rounded-full border border-black"
            code={market.countryCode}
          />
          <span>{market.countryName}</span>
        </>
      ) : (
        "Select market"
      )}
    </Button>
  );
}
